/** @returns {boolean} Default true when field is missing (legacy rows). */
export function readIsTeacher(value) {
  if (value == null || value === "") return true;
  if (value === false || value === 0) return false;
  if (value === true || value === 1) return true;
  const s = String(value).trim().toLowerCase();
  if (["false", "0", "no", "staff"].includes(s)) return false;
  if (["true", "1", "yes", "teacher"].includes(s)) return true;
  return true;
}

export function readIsLicensed(value) {
  if (value == null || value === "") return false;
  if (value === true || value === 1) return true;
  if (value === false || value === 0) return false;
  const s = String(value).trim().toLowerCase();
  return s === "true" || s === "1" || s === "yes";
}

/**
 * Resolve numeric database PK for license activate/deactivate.
 * Uses GET /Teacher/list or /TeacherLicense/list row `id` — never regNumber/matricule.
 * @returns {{ id: number|null, source: string|null, regNumber: string|null }}
 */
export function resolveTeacherDatabaseId(row) {
  if (!row) return { id: null, source: null, regNumber: null };
  const regNumber = String(row.regNumber ?? row.RegNumber ?? "").trim() || null;
  const candidates = [
    ["id", row.id],
    ["Id", row.Id],
    ["teacherId", row.teacherId],
    ["TeacherId", row.TeacherId],
  ];
  for (const [source, raw] of candidates) {
    if (raw == null || raw === "") continue;
    const trimmed = String(raw).trim();
    if (regNumber && trimmed === regNumber) continue;
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) continue;
    return { id: n, source, regNumber };
  }
  return { id: null, source: null, regNumber };
}
